import '../constants/colors.js';
import '../constants/fonts.js';
import '../constants/theme.js';
import { FileMimeCategories, FileCategories } from '../constants/files.js';
import '../constants/color-variant.js';
import '../constants/zIndexList.js';

function getUrlExtension(url = "") {
    var _a, _b, _c, _d, _e;
    return (_e = (_d = (_c = (_b = (_a = url === null || url === void 0 ? void 0 : url.split(/[#?]/)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.split(".")) === null || _c === void 0 ? void 0 : _c.pop()) === null || _d === void 0 ? void 0 : _d.trim()) !== null && _e !== void 0 ? _e : "";
}
function getFileCategory(url = "", file = null) {
    if (file instanceof File) {
        const extension = file === null || file === void 0 ? void 0 : file.type;
        switch (extension) {
            case FileMimeCategories.JPG:
            case FileMimeCategories.JPEG:
            case FileMimeCategories.PNG: {
                return "image";
            }
            case FileMimeCategories.PDF: {
                return "pdf";
            }
        }
    }
    else if (!!url) {
        const extension = getUrlExtension(url === null || url === void 0 ? void 0 : url.toLowerCase());
        switch (extension) {
            case FileCategories.JPG:
            case FileCategories.JPEG:
            case FileCategories.PNG: {
                return "image";
            }
            case FileCategories.PDF: {
                return "pdf";
            }
        }
    }
    return undefined;
}

export { getFileCategory, getUrlExtension };
//# sourceMappingURL=files.js.map
